// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер для страницы вступивших членов */
.MembersPage_members-page__SIoXs {
  max-width: 800px;
  margin: 50px auto;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

/* Заголовок страницы */
.MembersPage_members-page__SIoXs h1 {
  text-align: center;
  color: #333333;
  margin-bottom: 30px;
  font-size: 2.5rem;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

/* Стили для списка членов */
.MembersPage_members-list__1ZS8h {
  list-style-type: none;
  padding: 0;
}

.MembersPage_members-item__xxz97 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  margin: 10px 0;
  border: 1px solid #cccccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: background-color 0.3s, transform 0.2s;
}

.MembersPage_members-item__xxz97:hover {
  background-color: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .MembersPage_members-page__SIoXs {
    padding: 15px;
  }

  .MembersPage_members-page__SIoXs h1 {
    font-size: 2rem;
  }

  .MembersPage_members-item__xxz97 {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/Members/MembersPage.module.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Контейнер для страницы вступивших членов */\r\n.members-page {\r\n  max-width: 800px;\r\n  margin: 50px auto;\r\n  padding: 20px;\r\n  background-color: #ffffff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Заголовок страницы */\r\n.members-page h1 {\r\n  text-align: center;\r\n  color: #333333;\r\n  margin-bottom: 30px;\r\n  font-size: 2.5rem;\r\n  font-weight: bold;\r\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Стили для списка членов */\r\n.members-list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.members-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px;\r\n  margin: 10px 0;\r\n  border: 1px solid #cccccc;\r\n  border-radius: 8px;\r\n  background-color: #f9f9f9;\r\n  transition: background-color 0.3s, transform 0.2s;\r\n}\r\n\r\n.members-item:hover {\r\n  background-color: #e9ecef;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Адаптивность для мобильных устройств */\r\n@media (max-width: 768px) {\r\n  .members-page {\r\n    padding: 15px;\r\n  }\r\n\r\n  .members-page h1 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .members-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"members-page": `MembersPage_members-page__SIoXs`,
	"members-list": `MembersPage_members-list__1ZS8h`,
	"members-item": `MembersPage_members-item__xxz97`
};
export default ___CSS_LOADER_EXPORT___;
